export enum TypeCrvEnum {
  Blue,
  Green,
  White,
  Digital,
}
